import { init } from "../init-trello";

import { App } from "./app";
import { PageModel } from "./models";

console.log("[trello-test-page] Script loaded!", {
    hasWindow: typeof window !== "undefined",
    hasDocument: typeof document !== "undefined",
    hasPageModel: !!(window as Window & { pageModel?: unknown }).pageModel
});

// Wrap initialization to ensure it runs after DOM is ready
const initializeApp = () => {
    console.log(
        "[trello-test-page] Initializing app, readyState:",
        document.readyState
    );

    // Get the page model from the window (set by SSR)
    const defaultPageModel = (
        window as unknown as { pageModel: PageModel | null }
    ).pageModel;

    console.log("[trello-test-page] Client-side initialization:", {
        hasWindowPageModel:
            defaultPageModel !== null && defaultPageModel !== undefined,
        pageModelId: defaultPageModel?.id,
        pageModelType: defaultPageModel?.type,
        readyState: document.readyState,
        bodyExists: !!document.body,
        rootExists: !!document.getElementById("trello-portal-root")
    });

    // Initialize the app regardless - getRoute will return PlaceholderPage when needed
    init(App, { defaultPageModel: defaultPageModel || undefined });
};

// Ensure DOM is ready before initializing
// Check multiple states since module scripts can load at different times
if (document.readyState === "loading") {
    console.log(
        "[trello-test-page] DOM still loading, waiting for DOMContentLoaded"
    );
    document.addEventListener("DOMContentLoaded", initializeApp);
} else if (
    document.readyState === "interactive" &&
    !document.getElementById("trello-portal-root")
) {
    // DOM is being parsed but body might not be ready yet
    console.log(
        "[trello-test-page] DOM interactive but root not found, waiting for DOMContentLoaded"
    );
    document.addEventListener("DOMContentLoaded", initializeApp);
} else {
    // DOM is ready (either interactive with body, or complete)
    console.log(
        "[trello-test-page] DOM already ready, initializing immediately"
    );
    initializeApp();
}
